import React from "react";
import "../Style/WhatWeCurate.css";
import ritualOne from "../assets/NewPhotos/RitualPhoto/Ritual1.png";
import ritualTwo from "../assets/NewPhotos/RitualPhoto/Ritual2.png";
import ritualThree from "../assets/NewPhotos/RitualPhoto/Ritual3.png";
import ritualFour from "../assets/NewPhotos/RitualPhoto/Ritual4.png";

const CURATE_ITEMS = [
  {
    image: ritualOne,
    name: "Place the candle\nbeneath the balloon",
    alt: "Illustrated hot air balloon basket",
  },
  {
    image: ritualTwo,
    name: "Switch on the light to\ngently warm",
    alt: "Illustrated hot air balloon with flowers",
  },
  {
    image: ritualThree,
    name: "Watch the fragrance\nunfold and fill the space",
    alt: "Illustrated floral hot air balloon with rising smoke",
  },
  {
    image: ritualFour,
    name: "Elevate your everyday",
    alt: "Illustrated armchair with a balloon arrangement on a side table",
  },
];

function WhatWeCurate() {
  return (
    <section className="curate">
      <div className="curate-header">
        <h2 className="curate-title">The Ritual</h2>
      </div>

      <div className="curate-grid">
        {CURATE_ITEMS.map((item) => (
          <article className="curate-card" key={item.name}>
            <div className="curate-card-image-wrap">
              <img src={item.image} alt={item.alt} />
            </div>
            <div className="curate-card-body">
              <p className="curate-card-name">
                {item.name.split("\n").map((line, index) => (
                  <React.Fragment key={line}>
                    {line}
                    {index < item.name.split("\n").length - 1 && <br />}
                  </React.Fragment>
                ))}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default WhatWeCurate;
